import Footer from "../components/Footer";
import "../styles/Contact.css";
import { FaInstagram } from "react-icons/fa";
import { MdEmail } from "react-icons/md";
import { FaFacebookSquare } from "react-icons/fa";
import { FaLinkedin } from "react-icons/fa";
import { MdHomeFilled } from "react-icons/md";
import { FaMousePointer } from "react-icons/fa";
import { FaPhoneAlt } from "react-icons/fa";
import { useEffect, useMemo, useState } from "react";


export default function Contact() {
  const isSubmitted = new URLSearchParams(window.location.search).get("submitted") === "1";
  const nextUrl = useMemo(() => `${window.location.origin}/contact?submitted=1`, []);
  const [showSuccessPopup, setShowSuccessPopup] = useState(isSubmitted);

  useEffect(() => {
    if (!isSubmitted) {
      return undefined;
    }

    const timerId = window.setTimeout(() => {
      setShowSuccessPopup(false);
    }, 4500);

    return () => window.clearTimeout(timerId);
  }, [isSubmitted]);

  return (
    <>
      {showSuccessPopup ? (
        <div className="contact-popup-overlay" role="dialog" aria-modal="true">
          <div className="contact-popup">
            <p>Envoyé ! Votre message a bien été transmis.</p>
            <button type="button" onClick={() => setShowSuccessPopup(false)}>
              Fermer
            </button>
          </div>
        </div>
      ) : null}

      <div className="contact-hero">
        <div className="hero-bg"></div>
        <h1 className="contact-title">CONTACT</h1>
      </div>

      <section className="contact-wrapper">
        <div className="contact-card">
          <div className="contact-left">
            <h2>
              <MdHomeFilled />
              31 Rue de Mogador<br />
              75009 Paris Saint-Lazare
            </h2>

            <p>
              <MdEmail /> contact@le-hyve.com<br />
              <FaPhoneAlt /> 01 88 61 39 85
            </p>

            <div className="social">
              <h2>Suivez-nous <FaMousePointer /></h2>
              <p>@lehyve.paris</p>

              <div className="icons">
                <a href="https://instagram.com/lehyve.paris" target="_blank" rel="noreferrer" aria-label="Instagram Le Hyve">
                  <FaInstagram />
                </a>
                <span aria-label="Facebook Le Hyve">
                  <FaFacebookSquare />
                </span>
                <span aria-label="LinkedIn Le Hyve">
                  <FaLinkedin />
                </span>
              </div>
            </div>
          </div>

          <div className="contact-right">
            <h1>Formulaire de contact</h1>

            {isSubmitted ? (
              <div className="contact-success">
                Merci, votre message a bien été envoyé. Nous revenons vers vous rapidement.
              </div>
            ) : null}

            <form action="https://formsubmit.co/contact@le-hyve.com" method="POST">
              <input type="hidden" name="_subject" value="Nouveau message - Formulaire contact Le Hyve" />
              <input type="hidden" name="_captcha" value="false" />
              <input type="hidden" name="_next" value={nextUrl} />
              <input type="text" name="_honey" className="contact-honey" tabIndex="-1" autoComplete="off" />

              <label>Identité</label>
              <div className="row">
                <input type="text" name="nom" placeholder="Nom" required />
                <input type="text" name="prenom" placeholder="Prénom" required />
              </div>

              <label>Adresse e-mail</label>
              <input type="email" name="email" placeholder="email@example.com" required />

              <label>Objet</label>
              <input type="text" name="objet" placeholder="Sujet" required />

              <label>Message</label>
              <textarea name="message" placeholder="Votre message..." required />

              <label className="checkbox">
                <input type="checkbox" name="consentement" required />
                <span>
                  En cochant cette case, j’accepte de recevoir les nouveautés, les offres
                  et informations de Le Hyve et j’accepte la politique de confidentialité.
                </span>
              </label>

              <button type="submit">Envoyer</button>
            </form>
          </div>
        </div>

        <div className="question-box">
          <h2>UNE QUESTION ?</h2>
          <a className="contact-btn" href="mailto:contact@le-hyve.com">Contactez-nous</a>
        </div>
      </section>

      <Footer backgroundColor="black" />
    </>
  );
}